'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import { bindAll } from 'underscore';
import makeAsyncModal from 'DesignComponents/modals/makeAsyncModal';
import { FolderPropTypes } from 'DesignData/propTypes/finder';
import { PropTypes } from 'prop-types';
const NewFileWizard = makeAsyncModal(() => import(
/* webpackChunkName: "modals" */
'DesignFinderUI/components/modals/newFile/NewFileWizard'));
export default function withNewFileWizard(WrappedComponent) {
  class HighOrderWithNewFileWizard extends Component {
    constructor(props) {
      super(props);
      bindAll(this, ['handleNewFileCallback', 'handleNewFileClick', 'renderNewFileWizard', 'handleOnboardingNewTemplate']);
      this.state = {
        open: false,
        initialStep: 0
      };
    }

    handleNewFileCallback() {
      this.setState({
        open: false
      });
    }

    handleNewFileClick() {
      this.setState({
        open: true
      });
    }

    handleOnboardingNewTemplate() {
      this.setState({
        open: true,
        initialStep: 1
      });
    }

    renderNewFileWizard() {
      const {
        folderId,
        initialFileType
      } = this.props;
      const {
        open,
        initialStep
      } = this.state;

      if (!(open && folderId)) {
        return null;
      }

      return /*#__PURE__*/_jsx(NewFileWizard, {
        callback: this.handleNewFileCallback,
        folderId: folderId,
        initialStep: initialStep,
        initialFileType: initialFileType
      });
    }

    render() {
      const renderedNewFileWizard = this.renderNewFileWizard();
      return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, this.props, {
        NewFileWizard: renderedNewFileWizard,
        onNewFileClick: this.handleNewFileClick,
        handleOnboardingNewTemplate: this.handleOnboardingNewTemplate
      }));
    }

  }

  HighOrderWithNewFileWizard.propTypes = {
    folderId: FolderPropTypes.folderId,
    initialFileType: PropTypes.string
  };
  HighOrderWithNewFileWizard.defaultProps = {
    folderId: null
  };
  return HighOrderWithNewFileWizard;
}